export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-2.4dfac935.png";